// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3qFmK","inputWrap":"styles_inputWrap__3uZWt","input":"styles_input__3Cb9y"};